

export const memberSearchEschema = [

{
    id:1,
    name:'Name',
    type:'text',
    labelTitle:'Nombre'
},
{
    id:2,
    name:'LastName',
    type:'text',
    labelTitle:'Apellido'
},
{
    id:3,
    name:'Dni',
    type:'text',
    labelTitle:'Nro de Documento'
},
{
    id:4,
    name:'Email',
    type:'text',
    labelTitle:'Email o Teléfono'
},
{
    id:5,
    name:'FormationPlaceId',
    select:'true',
    labelTitle:'Lugar de formación'
},
]